import { useUserActiveOrganization } from "@/api";
import { PageHeader } from "@/components/ui/PageHeader";
import OrganizationBasics from "./OrganizationBasics/OrganizationBasics";
import { Subscriptions } from "./Subscriptions";

export const OrganizationSettings = () => {
  const { activeOrganization } = useUserActiveOrganization();

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        header="Organization settings"
        subHeader={activeOrganization?.name}
      />
      <div className="gap-4 flex flex-col">
        <OrganizationBasics />
        {activeOrganization && (
          <Subscriptions organization={activeOrganization} />
        )}
      </div>
    </div>
  );
};
